module.exports = {
  message: {
    service_desc: 'Используйте утилиту для обмена COS между различными форматами токенов, включая <strong>MainNet Native COS , BEP2 , ERC-20 и BEP-20.</strong>',
    choose_token_type: 'Направление обмена токеном',
    fee_tips: '',
    token_type_erc20_to_bep2: 'ERC-20 => BEP2',
    token_type_erc20_to_native: 'ERC-20 => MainNet Native COS',
    token_type_bep2_to_erc20: 'BEP2 => ERC-20',
    token_type_bep2_to_native: 'BEP2 => MainNet Native COS',
    token_type_native_to_erc20: 'MainNet Native COS => ERC-20',
    token_type_native_to_bep2: 'MainNet Native COS => BEP2',
    token_type_bep20_to_native: 'BEP-20 => MainNet Native COS',
    token_type_native_to_bep20: 'MainNet Native COS => BEP-20',
    enter_address: 'Токен swap целевой учетной записи / адрес',
    enter_exchange_memo: 'Memo (адрес получателя является обменом. Пожалуйста, укажите Memo, чтобы правильно получить COS)',
    create_account_tips: 'У вас нет аккаунта? Создайте!',
    next_btn: 'Следующий шаг',
    start_over_btn: 'Перезапустить',
    ready_to_swap: 'ГОТОВ Swap',
    transfer_prefix: 'Перевести ваш {token}в',
    address: 'АККАУНТ / АДРЕС',
    memo: 'MEMO',
    auto_swap_desc: 'Убедитесь, что вы правильно ввели УЧЕТНУЮ ЗАПИСЬ / АДРЕС. Утилита подкачки токенов отправит соответствующее количество токенов COS на указанный кошелек после получения вашего токена. <strong>Процесс может занять около 5 минут<strong>.',
    auto_swap_desc_memo: 'Убедитесь, что вы правильно ввели УЧЕТНУЮ ЗАПИСЬ / АДРЕС и МЕМО. Утилита подкачки токенов отправит соответствующее количество токенов COS на указанный кошелек после получения вашего токена. <strong>Процесс может занять около 5 минут<strong>.',
    main_net_address: 'Учетная запись основной сети Contentos',
    bep2_address: 'Адрес BEP2',
    erc20_address: 'Адрес ERC-20',
    bep20_address: 'Адрес BEP-20',
    main_net_token: 'MainNet Native COS',
    bep2_token: 'BEP2 COS',
    erc20_token: 'ERC-20 COS',
    bep20_token: 'BEP-20 COS',
    ok: 'Подтвердить',
    Cancel: 'Отмена',
    tips: 'Примечания',
    enter_address_tips: 'Пожалуйста, заполните правильный адрес',
    enter_exChange_memo_tips: 'Пожалуйста, введите правильное Memo',
    swap_address_invalid: 'Неверный адрес',
    swap_address_not_exit: 'Аккаунт не существует',
    swap_type_invalid: 'Неверное направление swap токеном',
    swap_system_error: 'Пожалуйста, повторите попытку позже',
    swap_unknown_error: 'Произошла неизвестная ошибка. Пожалуйста, повторите попытку позже.',
    swap_memo_invalid: 'Invalid Memo',
    invalid_bnb_exChange_memo_tips: 'Binance exchange memo should be a number'
  }
}
